var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckMarkIcon = function SvgCheckMarkIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.1001,
    width: 2,
    height: 6.08564,
    transform: "rotate(-45 0 8.1001)",
    fill: "#186346"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.41418,
    y: 12.5137,
    width: 2,
    height: 14.99,
    transform: "rotate(-135 4.41418 12.5137)",
    fill: "#186346"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckMarkIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iOC4xMDAxIiB3aWR0aD0iMiIgaGVpZ2h0PSI2LjA4NTY0IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMCA4LjEwMDEpIiBmaWxsPSIjMTg2MzQ2Ii8+CjxyZWN0IHg9IjQuNDE0MTgiIHk9IjEyLjUxMzciIHdpZHRoPSIyIiBoZWlnaHQ9IjE0Ljk5IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDQuNDE0MTggMTIuNTEzNykiIGZpbGw9IiMxODYzNDYiLz4KPC9zdmc+Cg==";